<template lang="pug">
  div
    h1 Mis resultados
    .tree-wrapper.stat-box-wrapper
      .stat-box(v-if="questions")
        label Preguntas
        span.value {{questions}}
      .stat-box(v-if="questions_ok_percentage")
        label Preguntas acertadas
        span.value {{questions_ok_percentage}}
      .stat-box(v-if="questions_wrong_percentage")
        label Preguntas erradas
        span.value {{questions_wrong_percentage}}
      .stat-box(v-if="questions_empty_percentage")
        label Preguntas sin responder
        span.value {{questions_empty_percentage}}
      .stat-box(v-if="tests")
        label Pruebas realizadas
        span.value {{tests}}
      .stat-box(v-if="points")
        label Puntos
        span.value {{points}}
      .stat-box(v-if="minutes")
        label Tiempo invertido
        span.value {{minutes}}
    h3.wrong-questions-title(v-if="wrong_questions.length") Preguntas más falladas
      .wrapper-worst-questions
        .wrapper-worst-question(v-for="question in wrong_questions")
          WorstQuestion(:question="question")
</template>

<script type="text/javascript">
import _ from "underscore";
import api from "@/service/api";
import { mapState } from "vuex";
import WorstQuestion from "@/components/WorstQuestion"

export default {
  name: "Stats",
  computed: mapState(["token", "username"]),
  components: {WorstQuestion},
  data() {
    return {
      minutes: null,
      points: null,
      questions: null,
      questions_ok_percentage: null,
      questions_wrong_percentage: null,
      questions_empty_percentage: null,
      tests: null,
      wrong_questions: [],
    };
  },
  created: function () {
    const self = this;

    api
      .me(self.token)
      .then((response) => {
        const data = response.data;
        self.minutes = data.stats.minutes_human;
        self.points = data.stats.points;
        self.questions = data.stats.questions;
        self.questions_ok_percentage = data.stats.questions_ok_percentage;
        self.questions_wrong_percentage = data.stats.questions_wrong_percentage;
        self.questions_empty_percentage = data.stats.questions_empty_percentage;
        self.tests = data.stats.tests;
      })
      .catch((err) => {});

    api.wrongQuestions(self.token).then(response => {
      const data = response.data
      self.wrong_questions = data.questions
    }).catch(err => {

    })
  },
};
</script>
